<template>
  <div class="ab-layout redis-query-panel">
    <el-card class="workspace-card query-card" shadow="hover">
      <template #header>
        <div class="card-header">
          <span>查询 Redis 数据</span>
          <el-button :loading="redisQueryLoading" @click="loadRedisTopLevel">刷新分类</el-button>
        </div>
      </template>

      <div class="query-mode-wrap">
        <el-radio-group v-model="redisQueryMode">
          <el-radio-button value="nonVersion">非版本分类</el-radio-button>
          <el-radio-button value="version">版本分类</el-radio-button>
        </el-radio-group>
      </div>
      <div class="query-summary-strip">
        <div class="query-summary-item">
          <span class="query-summary-label">查询库</span>
          <strong>DB1 / mazda</strong>
        </div>
        <div class="query-summary-item">
          <span class="query-summary-label">基础前缀</span>
          <strong>api:olinfo</strong>
        </div>
        <div v-if="redisQueryMode === 'nonVersion'" class="query-summary-item">
          <span class="query-summary-label">当前模式</span>
          <strong>非版本分类直查</strong>
        </div>
        <div v-else class="query-summary-item">
          <span class="query-summary-label">当前模式</span>
          <strong>版本 → 下一级分类</strong>
        </div>
      </div>

      <div v-if="redisQueryMode === 'nonVersion'" class="query-toolbar query-toolbar-3">
        <el-select v-model="redisSelectedNonVersion" placeholder="选择非版本分类" class="field-item">
          <el-option v-for="item in redisNonVersionOptions" :key="item" :label="item" :value="item" />
        </el-select>

        <div class="toolbar-tip">当前读取：api:olinfo:{{ redisSelectedNonVersion || '-' }}:*</div>

        <div class="toolbar-actions">
          <el-button type="primary" :loading="redisQueryLoading" @click="loadRedisItems">读取内容</el-button>
        </div>
      </div>

      <div v-else class="query-toolbar query-toolbar-4">
        <el-select v-model="redisSelectedVersion" placeholder="选择版本" class="field-item" @change="handleRedisVersionChange">
          <el-option v-for="item in redisVersionOptions" :key="item" :label="item" :value="item" />
        </el-select>

        <el-select v-model="redisSelectedVersionChild" placeholder="选择下一级分类" class="field-item">
          <el-option v-for="item in redisVersionChildOptions" :key="item" :label="item" :value="item" />
        </el-select>

        <div class="toolbar-tip">当前读取：api:olinfo:{{ redisSelectedVersion || '-' }}:{{ redisSelectedVersionChild || '-' }}:*</div>

        <div class="toolbar-actions">
          <el-button type="primary" :loading="redisQueryLoading" @click="loadRedisItems">读取内容</el-button>
        </div>
      </div>
    </el-card>

    <el-card class="workspace-card ab-list-card" shadow="hover">
      <template #header>
        <div class="card-header redis-list-header">
          <span>Redis 内容列表</span>
          <div class="header-actions redis-header-actions">
            <el-input
              v-model="redisKeyword"
              placeholder="搜索键值 / 完整 Key / 类型 / 内容预览"
              clearable
              class="redis-search-input"
              @clear="handleRedisKeywordChange"
              @input="handleRedisKeywordChange"
            />
            <el-button v-if="redisQueryExecuted" type="warning" plain class="add-redis-btn" @click="openAddRedisDialog">添加数据</el-button>
            <div class="list-count-wrap"><span class="list-count-text">筛选后 {{ redisFilteredItems.length }} 条 / 共 {{ redisQueryItems.length }} 条</span></div>
          </div>
        </div>
      </template>

      <div class="table-scroll-shell">
        <div class="table-scroll-inner redis-table-scroll-inner">
          <el-table
            :data="redisPagedItems"
            stripe
            border
            class="result-table redis-result-table"
            v-loading="redisQueryLoading"
            empty-text="暂无查询结果"
          >
            <el-table-column prop="leafKey" label="键值" min-width="120" />
            <el-table-column prop="fullKey" label="完整 Key" min-width="320" show-overflow-tooltip />
            <el-table-column prop="valueType" label="类型" width="100" />
            <el-table-column prop="valuePreview" label="内容预览" min-width="420" show-overflow-tooltip />
            <el-table-column label="操作" width="140" align="center" class-name="action-column">
              <template #default="scope">
                <el-button type="primary" size="small" class="view-content-btn" @click="showRedisDetail(scope.row)">查看内容</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="redisQueryExecuted" class="pagination-wrap ab-pagination-wrap redis-pagination-wrap">
            <div class="ab-pagination-left">当前第 {{ redisPage }} / {{ redisTotalPages }} 页</div>
            <div class="ab-pagination-right">
              <span class="pager-label">每页</span>
              <el-select v-model="redisPageSize" class="page-size-select redis-page-size-select" @change="handleRedisSizeChange">
                <el-option :value="10" label="10 条" />
                <el-option :value="20" label="20 条" />
                <el-option :value="50" label="50 条" />
                <el-option :value="100" label="100 条" />
                <el-option :value="200" label="200 条" />
              </el-select>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="redisFilteredItems.length"
                :current-page="redisPage"
                :page-size="redisPageSize"
                @current-change="handleRedisPageChange"
              />
              <span class="pager-label">跳至</span>
              <el-input v-model="redisJumpPage" class="jump-input" @keyup.enter="handleRedisJump" />
              <span class="pager-label">页</span>
              <el-button @click="handleRedisJump">确定</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <el-dialog v-model="addRedisDialogVisible" title="添加 Redis 数据" width="760px">
      <div class="ab-detail-meta">
        <div class="result-row"><span>目标前缀</span><strong>{{ redisCurrentPrefix || '-' }}</strong></div>
        <div class="result-row"><span>完整 Key</span><strong>{{ redisAddFullKey || '-' }}</strong></div>
        <div class="result-row"><span>默认类型</span><strong>{{ redisSuggestedValueTypeLabel }}</strong></div>
      </div>

      <div class="add-redis-form">
        <el-input v-model="redisAddLeafKey" placeholder="请输入新增键值（最后一级）" />
        <el-select v-model="redisAddValueType" class="add-redis-type-select">
          <el-option label="string" value="string" />
          <el-option label="hash" value="hash" />
        </el-select>
      </div>

      <div class="redis-detail-tip-line add-redis-tip-line">
        <span v-if="redisAddValueType === 'hash'">Hash 类型请输入合法 JSON 对象，例如 {&quot;carid&quot;:&quot;20&quot;,&quot;result&quot;:&quot;J59J&quot;}。</span>
        <span v-else>String 类型按原始文本保存。</span>
      </div>

      <el-input
        v-model="redisAddContent"
        type="textarea"
        :rows="14"
        resize="none"
        class="ab-detail-textarea redis-detail-editor"
        :readonly="redisAddSubmitting"
        :placeholder="redisAddValueType === 'hash' ? '请输入 JSON 对象内容' : '请输入字符串内容'"
      />

      <template #footer>
        <div class="dialog-footer">
          <el-button :disabled="redisAddSubmitting" @click="addRedisDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="redisAddSubmitting" @click="submitAddRedisData">确认添加</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-model="show_key_value" title="查看 Redis 数据详情" width="88%">
      <div class="ab-detail-meta">
        <div class="result-row"><span>完整 Key</span><strong>{{ redisDetailFullKey || '-' }}</strong></div>
        <div class="result-row"><span>类型</span><strong>{{ redisDetailType || '-' }}</strong></div>
      </div>

      <div class="redis-detail-toolbar">
        <div class="redis-detail-toolbar-group">
          <span class="toolbar-label">查看方式</span>
          <el-radio-group v-model="redisDetailViewMode" size="small">
            <el-radio-button value="raw">原始内容</el-radio-button>
            <el-radio-button value="json" :disabled="!redisDetailJsonAvailable">JSON 解析</el-radio-button>
          </el-radio-group>
        </div>

        <div v-if="redisDetailJsonAvailable" class="redis-detail-toolbar-group">
          <span class="toolbar-label">数字显示</span>
          <el-radio-group v-model="redisDetailNumberBase" size="small">
            <el-radio-button value="dec">十进制</el-radio-button>
            <el-radio-button value="hex">十六进制</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div class="redis-detail-tip-line">
        <span v-if="redisDetailViewMode === 'json' && redisDetailJsonAvailable">
          JSON 模式下可直接修改并保存{{ redisDetailNumberBase === 'hex' ? '，整数会按原整数类型回写' : '' }}。
        </span>
        <span v-else>原始内容模式下可直接修改并保存。</span>
      </div>

      <el-input
        v-model="redisDetailEditorText"
        type="textarea"
        :rows="20"
        resize="none"
        class="ab-detail-textarea redis-detail-editor"
        :readonly="redisDetailSaving"
      />

      <template #footer>
        <div class="dialog-footer redis-detail-footer">
          <el-button :disabled="redisDetailSaving" @click="cancelSelect">关闭</el-button>
          <el-button type="warning" plain class="add-redis-btn" :loading="redisDetailSaving" @click="deleteRedisDetail">删除该条</el-button>
          <el-button type="primary" :loading="redisDetailSaving" @click="saveRedisDetail">保存修改</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { toRef } from 'vue';
import { useMazdaRedisQuery } from '@/composables/mazda/useMazdaRedisQuery';

const props = defineProps({
  serverName: { type: String, required: true },
  mazdaPost: { type: Function, required: true },
});

const {
  redisQueryMode,
  redisVersionOptions,
  redisNonVersionOptions,
  redisVersionChildOptions,
  redisSelectedVersion,
  redisSelectedVersionChild,
  redisSelectedNonVersion,
  redisQueryItems,
  redisQueryLoading,
  redisQueryExecuted,
  redisKeyword,
  redisPage,
  redisPageSize,
  redisJumpPage,
  addRedisDialogVisible,
  redisAddLeafKey,
  redisAddValueType,
  redisAddContent,
  redisAddSubmitting,
  show_key_value,
  redisDetailFullKey,
  redisDetailType,
  redisDetailJsonAvailable,
  redisDetailViewMode,
  redisDetailNumberBase,
  redisDetailEditorText,
  redisDetailSaving,
  redisCurrentPrefix,
  redisSuggestedValueTypeLabel,
  redisAddFullKey,
  redisFilteredItems,
  redisTotalPages,
  redisPagedItems,
  loadRedisTopLevel,
  handleRedisVersionChange,
  loadRedisItems,
  handleRedisKeywordChange,
  handleRedisPageChange,
  handleRedisSizeChange,
  handleRedisJump,
  openAddRedisDialog,
  submitAddRedisData,
  showRedisDetail,
  saveRedisDetail,
  deleteRedisDetail,
  cancelSelect,
} = useMazdaRedisQuery(props.mazdaPost, toRef(props, 'serverName'));
</script>

<style scoped>
.ab-layout {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.workspace-grid.two-cols {
  display: grid;
  grid-template-columns: repeat(2, minmax(340px, 1fr));
  gap: 22px;
}

.workspace-card,
.ab-list-card,
.query-card {
  border-radius: 24px;
  border: 1px solid rgba(225, 232, 242, 0.95);
  box-shadow: 0 12px 30px rgba(29, 46, 76, 0.07);
}

.workspace-card :deep(.el-card__body),
.ab-list-card :deep(.el-card__body),
.query-card :deep(.el-card__body) {
  padding-top: 16px;
  padding-bottom: 16px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  font-weight: 800;
  color: #1f2d3d;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.upload-block {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 6px 0 4px;
}

.upload-block :deep(.el-button),
.header-actions :deep(.el-button),
.path-actions :deep(.el-button),
.action-row :deep(.el-button),
.toolbar-actions :deep(.el-button),
.dialog-footer :deep(.el-button) {
  min-width: 96px;
}

.ml-12 {
  margin-left: 12px;
}

.info-block {
  margin-top: 18px;
  padding: 16px 18px;
  border-radius: 16px;
  background: linear-gradient(180deg, #fbfcff, #f6f9ff);
  border: 1px solid #ecf2ff;
}

.info-row,
.result-row {
  display: flex;
  gap: 12px;
  line-height: 1.9;
}

.info-label,
.result-row span:first-child {
  width: 90px;
  color: #8a94a6;
  flex-shrink: 0;
}

.info-value,
.result-row strong {
  color: #2f3441;
  word-break: break-all;
}

.path-box {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.path-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.tips-box {
  margin-top: 18px;
  padding: 16px 18px;
  border-radius: 16px;
  background: linear-gradient(180deg, #fffaf0, #fff7e6);
  border: 1px solid #ffe4ad;
}

.tip-line {
  line-height: 1.9;
  color: #7a5600;
}

.action-row {
  display: flex;
  gap: 12px;
  margin-top: 22px;
  flex-wrap: wrap;
}

.result-panel {
  min-height: 150px;
  padding: 16px 18px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f7fbff, #f4f8ff);
  border: 1px solid #e8f1ff;
}

.empty-result {
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  border-radius: 16px;
  background: #fafafa;
  border: 1px dashed #dcdfe6;
}

.result-table,
.detail-table {
  width: 100%;
}

.result-table :deep(.el-table__inner-wrapper::before) {
  height: 0;
}


.table-scroll-shell {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  padding-bottom: 4px;
}

.table-scroll-inner {
  min-width: 100%;
}

.redis-table-scroll-inner {
  min-width: 1180px;
}

.pagination-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

.ab-pagination-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.ab-pagination-left {
  color: #606266;
  font-weight: 600;
}

.ab-pagination-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.page-size-select {
  width: 110px;
}

.jump-input {
  width: 72px;
}

.pager-label {
  color: #606266;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.ab-detail-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
  padding: 16px 18px;
  border-radius: 16px;
  background: linear-gradient(180deg, #fbfcff, #f6f9ff);
  border: 1px solid #ecf2ff;
}

.ab-detail-textarea :deep(.el-textarea__inner) {
  font-family: Consolas, "Courier New", monospace;
  line-height: 1.65;
  border-radius: 18px;
}


:deep(.action-column .cell) {
  overflow: visible;
  text-overflow: clip;
  white-space: nowrap;
  padding-left: 8px;
  padding-right: 8px;
}


.view-content-btn {
  min-width: 96px;
  font-weight: 700;
}

.view-content-btn:hover,
.view-content-btn:focus {
  color: #ffffff !important;
}

@media (max-width: 1180px) {
  .workspace-grid.two-cols {
    grid-template-columns: 1fr;
  }

  .toolbar-actions,
  .header-actions,
  .pagination-wrap,
  .ab-pagination-right {
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .ab-detail-meta {
    grid-template-columns: 1fr;
  }
}


.query-card {
  min-height: 0;
}

.query-mode-wrap {
  margin-bottom: 16px;
}

.query-toolbar {
  display: grid;
  grid-template-columns: repeat(4, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 0;
}

.query-toolbar-3 {
  grid-template-columns: minmax(220px, 260px) 1fr auto;
}

.query-toolbar-4 {
  grid-template-columns: minmax(220px, 240px) minmax(220px, 240px) 1fr auto;
}

.field-item {
  width: 100%;
}

.narrow-item {
  max-width: 160px;
}

.toolbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.toolbar-tip {
  display: flex;
  align-items: center;
  min-height: 42px;
  padding: 0 14px;
  border-radius: 14px;
  background: #f7faff;
  color: #667085;
  border: 1px solid #e6edf7;
  line-height: 1.6;
  word-break: break-all;
}

.query-summary-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0 0 12px;
}

.query-summary-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 14px;
  background: linear-gradient(180deg, #fbfcff, #f6f9ff);
  border: 1px solid #e8eef8;
  color: #4b5565;
  font-size: 13px;
}

.query-summary-label {
  color: #8a94a6;
}

.redis-list-header {
  gap: 16px;
  flex-wrap: wrap;
}

.redis-header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex: 1 1 auto;
  flex-wrap: wrap;
}

.redis-search-input {
  width: min(420px, 100%);
}

.list-count-wrap {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: #f7faff;
  border: 1px solid #e6edf7;
}

.list-count-text {
  color: #8a94a6;
  font-size: 13px;
  font-weight: 600;
}

.redis-pagination-wrap {
  justify-content: space-between;
}

.redis-pagination-wrap .ab-pagination-right {
  flex: 1 1 auto;
  justify-content: flex-end;
}

.redis-page-size-select {
  width: 120px;
  min-width: 120px;
}

.add-redis-btn {
  background: #fff3cd !important;
  border-color: #f4c542 !important;
  color: #9a6700 !important;
}

.add-redis-btn:hover,
.add-redis-btn:focus {
  background: #ffe69c !important;
  border-color: #e0a800 !important;
  color: #7a5300 !important;
}

.add-redis-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 140px;
  gap: 12px;
  margin-bottom: 14px;
}

.add-redis-type-select {
  width: 100%;
}

.add-redis-tip-line {
  margin-bottom: 12px;
}

.redis-detail-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  padding: 14px 16px;
  border-radius: 16px;
  background: linear-gradient(180deg, #fbfcff, #f6f9ff);
  border: 1px solid #ecf2ff;
}

.redis-detail-toolbar-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.toolbar-label {
  color: #6b7383;
  font-weight: 700;
  font-size: 13px;
}

.redis-detail-tip-line {
  margin-bottom: 12px;
  padding: 10px 14px;
  border-radius: 14px;
  background: #f7faff;
  border: 1px solid #e6edf7;
  color: #667085;
  line-height: 1.7;
}

.redis-detail-editor :deep(textarea) {
  font-family: Consolas, "Courier New", monospace;
  line-height: 1.7;
}

.redis-detail-footer {
  gap: 10px;
}

.query-card .toolbar-actions {
  justify-content: flex-end;
}

.query-card :deep(.el-radio-group) {
  display: inline-flex;
  flex-wrap: wrap;
}

.query-card .result-table {
  margin-top: 0;
}

@media (max-width: 1180px) {
  .query-toolbar {
    grid-template-columns: 1fr;
  }

  .query-summary-strip {
    flex-direction: column;
  }

  .query-card .toolbar-actions,
  .redis-pagination-wrap .ab-pagination-right,
  .redis-header-actions {
    justify-content: flex-start;
  }
}
</style>
